// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.wallet.client

import org.multipaz.cbor.DataItem
import org.multipaz.wallet.client.WalletClientSignedInUser
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.cbor.Bstr

fun WalletClientSignedInUser.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "PLzZpxbZ90UvSzrpc6lcahXhRjXCnCDLA36mK0IgYH4")
val WalletClientSignedInUser_cborSchemaId = ByteString(60, -68, -39, -89, 22, -39, -9, 69, 47, 75, 58, -23, 115, -87, 92, 106, 21, -31, 70, 53, -62, -100, 32, -53, 3, 126, -90, 43, 66, 32, 96, 126)

fun WalletClientSignedInUser.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("id", Tstr(this.id))
    val displayName = this.displayName
    if (displayName != null) {
        builder.put("displayName", Tstr(displayName))
    }
    val profilePicture = this.profilePicture
    if (profilePicture != null) {
        builder.put("profilePicture", Bstr(profilePicture.toByteArray()))
    }
    val profilePictureUrl = this.profilePictureUrl
    if (profilePictureUrl != null) {
        builder.put("profilePictureUrl", Tstr(profilePictureUrl))
    }
    return builder.end().build()
}

fun WalletClientSignedInUser_fromDataItem(dataItem: DataItem): WalletClientSignedInUser {
    val id = dataItem["id"].asTstr
    val displayName0 = if (dataItem.hasKey("displayName")) {
        dataItem["displayName"].asTstr
    } else {
        null
    }
    val profilePicture0 = if (dataItem.hasKey("profilePicture")) {
        dataItem["profilePicture"].let { ByteString(it.asBstr) }
    } else {
        null
    }
    val profilePictureUrl0 = if (dataItem.hasKey("profilePictureUrl")) {
        dataItem["profilePictureUrl"].asTstr
    } else {
        null
    }
    return WalletClientSignedInUser(
        id = id,
        displayName = displayName0,
        profilePicture = profilePicture0,
        profilePictureUrl = profilePictureUrl0,
    )
}
